function cov_1alnag9wq1() {
  var path = "/app/src/components/popup-learn-more-close/index.tsx";
  var hash = "03535f1aa8525ed399e20aaa975644b4056b20e7";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/popup-learn-more-close/index.tsx",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "03535f1aa8525ed399e20aaa975644b4056b20e7"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1alnag9wq1 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1alnag9wq1();
export { PopupLearnMoreClose } from './popup-learn-more-close';